import { ref } from "vue";

export const hideUserName = ref(false);
